const UNAUTHORIZED_WORKSPACE_FRAGMENT = "not authorized for one or more workspaces";

export const UNAUTHORIZED_WORKSPACE_TOAST = "You are not authorized to access this workspace";

type GraphQLErrorLike = {
  message?: string;
};

type ErrorLike = {
  message?: string;
  graphQLErrors?: GraphQLErrorLike[];
};

export const isUnauthorizedWorkspaceError = (error: unknown): boolean => {
  if (!error || typeof error !== "object") return false;
  const candidate = error as ErrorLike;
  if (
    candidate.graphQLErrors?.some((graphQLError) =>
      graphQLError.message?.includes(UNAUTHORIZED_WORKSPACE_FRAGMENT),
    )
  ) {
    return true;
  }
  return Boolean(candidate.message?.includes(UNAUTHORIZED_WORKSPACE_FRAGMENT));
};
